import { __decorate } from "tslib";
import { Injectable } from '@angular/core';
var DateValidationService = /*@__PURE__*/ (function () {
    function DateValidationService() {
        this.bankHolidays = ['1.1', '6.1', '1.5', '3.10', '25.12', '26.12'];
        this.months = [
            {
                name: 'Januar',
                value: 1
            },
            {
                name: 'Februar',
                value: 2
            },
            {
                name: 'März',
                value: 3
            },
            {
                name: 'April',
                value: 4
            },
            {
                name: 'Mai',
                value: 5
            },
            {
                name: 'Juni',
                value: 6
            },
            {
                name: 'Juli',
                value: 7
            },
            {
                name: 'August',
                value: 8
            },
            {
                name: 'September',
                value: 9
            },
            {
                name: 'Oktober',
                value: 10
            },
            {
                name: 'November',
                value: 11
            },
            {
                name: 'Dezember',
                value: 12
            }
        ];
        //Weekends
        this.weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        this.workDays = this.weekDays.slice(1, 6);
    }
    DateValidationService.prototype.getBankHolidays = function () {
        return this.bankHolidays;
    };
    DateValidationService.prototype.getMonths = function () {
        return this.months;
    };
    DateValidationService.prototype.isWeekend = function (date) {
        var weekDay = this.weekDays[date.getDay()];
        return -1 == this.workDays.indexOf(weekDay);
    };
    //Bank Holidays
    DateValidationService.prototype.isBankHoliday = function (date) {
        //fetch bankHolidays and create bankHolidays with selected year as Date
        var bankHolidays = this.getBankHolidays().map(function (datePrefixString) {
            var day = parseInt(datePrefixString.split('.')[0]);
            var month = parseInt(datePrefixString.split('.')[1]);
            return new Date(date.getFullYear(), month - 1, day);
        });
        // go through list and check if there is any bank holiday equals date
        var isBankHoliday = bankHolidays.filter(function (bankHoliday) {
            return (bankHoliday.getDate() == date.getDate() &&
                bankHoliday.getMonth() == date.getMonth() &&
                bankHoliday.getFullYear() == date.getFullYear());
        }).length != 0;
        return isBankHoliday;
    };
    DateValidationService.prototype.valMinWorkDaysInFuture = function (_a) {
        var today = _a.today, date = _a.date, minWorkDaysInFuture = _a.minWorkDaysInFuture;
        var minWorkingDateInFuture = new Date(today.toDateString());
        this.addWorkDays({ startDate: minWorkingDateInFuture, days: minWorkDaysInFuture });
        return minWorkingDateInFuture > date;
    };
    DateValidationService.prototype.valMinDaysInFuture = function (_a) {
        var today = _a.today, date = _a.date, minDaysInFuture = _a.minDaysInFuture;
        var minDateInFuture = new Date(today.toDateString());
        minDateInFuture.setDate(minDateInFuture.getDate() + minDaysInFuture);
        return minDateInFuture > date;
    };
    DateValidationService.prototype.valMaxDaysInFuture = function (_a) {
        var today = _a.today, date = _a.date, maxDaysInFuture = _a.maxDaysInFuture;
        var maxDateInFuture = new Date(today.toDateString());
        maxDateInFuture.setDate(maxDateInFuture.getDate() + maxDaysInFuture);
        return date > maxDateInFuture;
    };
    DateValidationService.prototype.valMaxDaysInPast = function (_a) {
        var today = _a.today, date = _a.date, maxDaysInPast = _a.maxDaysInPast;
        var maxDateInPast = new Date(today.toDateString());
        maxDateInPast.setDate(maxDateInPast.getDate() - maxDaysInPast);
        return maxDateInPast > date;
    };
    DateValidationService.prototype.addWorkDays = function (_a) {
        var startDate = _a.startDate, days = _a.days;
        // if (isNaN(days)) {
        //     console.log('Value provided for "days" was not a number');
        //     return;
        // }
        // if (!(startDate instanceof Date)) {
        //     console.log('Value provided for "startDate" was not a Date object');
        //     return;
        // }
        var dow = startDate.getDay();
        var daysToAdd = days;
        if (dow == 0)
            daysToAdd++;
        if (dow + daysToAdd >= 6) {
            var remainingWorkDays = daysToAdd - (5 - dow);
            daysToAdd += 2;
            if (remainingWorkDays > 5) {
                daysToAdd += 2 * Math.floor(remainingWorkDays / 5);
                if (remainingWorkDays % 5 == 0)
                    daysToAdd -= 2;
            }
        }
        startDate.setDate(startDate.getDate() + daysToAdd);
        return startDate;
    };
    return DateValidationService;
}());
export { DateValidationService };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/services/data-service.ts
// module id = null
// module chunks = 